import { useQuery } from "@tanstack/react-query";
import useRetryFetch from "./useRetryFetch";
import { listTakeaways, type UserTakeaway } from "../api/userTakeaways";

/** Soonest uncompleted step per project (takeaways rooted via pwfMeta.fiPwf).
 *  Shared by the PlantedCard grid (Plan A) and the Projects cards (Plan C). */
export function useNextStepsByProject(): {
  nextStepByProject: Record<string, UserTakeaway>;
  isLoading: boolean;
} {
  const retryFetch = useRetryFetch();
  const { data, isLoading } = useQuery({
    queryKey: ["home-today-actions"],
    queryFn: () => listTakeaways(retryFetch, { type: "action", status: "pending", limit: 200 }),
    staleTime: 30 * 1000,
  });
  const nextStepByProject: Record<string, UserTakeaway> = {};
  for (const tk of data?.list ?? []) {
    const pid = (tk as any).pwfMeta?.fiPwf;
    if (!pid || tk.parentId) continue;
    const cur = nextStepByProject[pid];
    const tkDue = tk.dueDate ?? Number.POSITIVE_INFINITY;
    const curDue = cur ? cur.dueDate ?? Number.POSITIVE_INFINITY : Number.POSITIVE_INFINITY;
    if (!cur || tkDue < curDue) nextStepByProject[pid] = tk;
  }
  return { nextStepByProject, isLoading };
}
